import { useEffect } from "react";
// Libraries
import { isEqual } from "lodash";
// Utils
import { usePrevious, useStateSpecies } from "hooks";

export const useEffectSpeciesActive = (callback: () => void): void => {
  const { active: speciesActive } = useStateSpecies();
  const previousSpeciesActive = usePrevious(speciesActive);

  useEffect(() => {
    if (!previousSpeciesActive) return;

    if (isEqual(previousSpeciesActive, speciesActive)) return;

    callback();
  }, [callback, previousSpeciesActive, speciesActive]);
};
